<template>
  <div
    class="buscador-grupos__component-home__desktop"
    :class="{ 'buscador-grupos__component-home__desktop-solo': !isSkiandnight }">
    <div class="buscador-grupos__component-home__desktop__container">
      <div class="dropdown-destino__container" :class="isSkiandnight ? 'dropdown-destino__solo' : ''">
        <div class="dropdown">
          <div id="dropdownBuscadorDestinosGrupos" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            <div class="dropdown-titulo">
              {{ $t('searcher.destiny.title') }}
            </div>
            <div class="dropdown-subtitulo">
              <template v-if="dataBuscadorGruposRealizado.lugarExperiencia">
                {{ titleCase(dataBuscadorGruposRealizado.lugarExperiencia.nombre) }}
              </template>
              <template v-else>
                {{ $t('searcher.destiny.subtitle') }}
              </template>
            </div>
            <i
              v-if="dataBuscadorGruposRealizado.lugarExperiencia"
              class="fa-solid fa-xmark text-primary"
              @click="limpiarDestinoBuscador" />
          </div>
          <ul class="dropdown-menu" aria-labelledby="dropdownBuscadorDestinoGrupos">
            <div
              v-for="destino in dataFiltroViajes.destino"
              :key="destino.id"
              class="item-menu__container"
              role="button">
              <div class="item-menu__opcion text-clickable" @click="sendDestinoBuscador(destino)">
                {{ titleCase(destino.nombre) }}
              </div>
            </div>
          </ul>
        </div>
      </div>
      <div v-if="!isSkiandnight" class="dropdown-fechas__container">
        <div class="dropdown">
          <div id="dropdownBuscadorFechasGrupos" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            <div class="dropdown-titulo">
              {{ $t('searcher.date.title') }}
            </div>
            <div class="dropdown-subtitulo">
              <template v-if="dataBuscadorGruposRealizado.date">
                {{ moment(dataBuscadorGruposRealizado.date).format('MMMM') }}
                -
                {{ dataBuscadorGruposRealizado.date.year }}
              </template>
              <template v-else>
                {{ $t('searcher.date.subtitle') }}
              </template>
            </div>
            <i
              v-if="dataBuscadorGruposRealizado.date"
              class="fa-solid fa-xmark text-primary"
              @click="limpiarFechaBuscador" />
          </div>
          <ul class="dropdown-menu" aria-labelledby="dropdownBuscadorFechasGrupos">
            <Datepicker
              inline
              month-picker
              auto-apply
              :min-date="new Date(2022, 11, 1)"
              @update:model-value="sendFechaBuscador" />
          </ul>
        </div>
      </div>
      <div class="boton-buscar__container">
        <div class="boton-buscar__lupa" @click="doBusquedaGrupos">
          <i class="fa-solid fa-magnifying-glass fa-2x boton-buscar__icono" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed, ref } from 'vue';
  import Datepicker from '@vuepic/vue-datepicker';
  import { titleCase } from '@/helpers/filters';
  import moment from 'moment-timezone';
  import { checkDomain, DOMAINS } from '@/helpers/domainUtils';

  const props = defineProps({
    informacionBusquedaGrupos: {
      type: Object,
      required: true,
    },
    filtroViajes: {
      type: Object,
      required: true,
    },
  });

  const emits = defineEmits([
    'limpiarDestinoBuscador',
    'setearDestinoBuscador',
    'limpiarFechaBuscador',
    'setearFechaBuscador',
    'doBusquedaViajesGrupos',
  ]);

  const isSkiandnight = checkDomain([DOMAINS.skiandnight]);
  const error = ref(false);

  const dataBuscadorGruposRealizado = computed(() => props.informacionBusquedaGrupos);
  const dataFiltroViajes = computed(() => props.filtroViajes);

  function limpiarDestinoBuscador() {
    emits('limpiarDestinoBuscador');
  }

  function limpiarFechaBuscador() {
    emits('limpiarFechaBuscador');
  }

  function sendDestinoBuscador(destino) {
    emits('setearDestinoBuscador', destino);
    document.getElementById('dropdownBuscadorDestinosGrupos').click();
  }

  function sendFechaBuscador(fecha) {
    document.getElementById('dropdownBuscadorFechasGrupos').click();
    emits('setearFechaBuscador', fecha);
  }

  function doBusquedaGrupos() {
    error.value = false;
    emits('doBusquedaViajesGrupos');
  }
</script>

<style lang="scss" scoped>
  @import '~@/assets/scss/san.scss';
  .buscador-grupos {
    &__component-home__desktop {
      @extend .text-start, .justify-content-center, .text-primary, .align-items-stretch, .d-none, .d-md-flex;
      height: 80px;
      background-color: rgba(255, 255, 255, 0.7);
      box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.5);
      border-radius: var(--bs-border-radius-xl);
      width: 100%;
      max-width: 780px;
      border-radius: var(--bs-border-radius-xxl);
      margin: auto;

      &-solo {
        max-width: 400px;
      }

      &__container {
        @extend .row, .justify-content-between, .align-items-center, .w-100;
        padding: 0.2rem 2rem;

        .dropdown {
          &-titulo {
            font-size: 18px;
            font-weight: 500;
            font-style: normal;
            padding-top: 0;

            &__error {
              @extend .text-danger;
              font-size: 1.125rem;
            }
          }

          &-subtitulo {
            @extend .position-relative;
            color: #5d5c6a;
            font-size: 0.8rem;
            font-style: normal;

            &__error {
              @extend .text-danger;
            }
          }

          .dropdown-menu {
            .item-menu__opcion {
              padding: 0.25rem 0;
            }

            .item-menu__descripcion {
              @extend .text-muted, .fw-normal, .mb-0;
              font-size: 0.8rem;
            }
          }

          .text-clickable:hover {
            text-decoration: underline;
            cursor: pointer;
          }

          &-destino {
            &__container {
              @extend .border-primary, .p-0;
              border-right: 1.5px solid;
              position: relative;

              &:not(.dropdown-destino__solo) {
                @extend .col-5;
              }

              &.dropdown-destino__solo {
                @extend .col;
                border-right: none;
              }

              .fa-xmark {
                font-size: 17px;
                cursor: pointer;
                position: absolute;
                right: 10px;
                top: 50%;
                transform: translateY(-50%);
              }

              .dropdown-menu {
                @extend .px-2;
                min-width: 300px !important;
                width: auto !important;

                &__container {
                  @extend .d-flex, .justify-content-start, .py-2;

                  .item-menu {
                    &__container {
                      @extend .ps-2;
                      width: auto !important;
                      row-gap: 1rem;
                    }
                  }
                }
              }
            }
          }

          &-fechas {
            &__container {
              @extend .col-5, .border-primary, .px-0;
              position: relative;

              .fa-xmark {
                font-size: 17px;
                cursor: pointer;
                position: absolute;
                right: 10px;
                top: 50%;
                transform: translateY(-50%);
              }
            }
          }
        }

        .boton-buscar {
          &__container {
            @extend .col-auto, .text-end, .pe-0;
          }

          &__lupa {
            @extend .px-0;
            cursor: pointer;
            transition: 0.3s ease-in-out;

            &:hover {
              transform: scale(1.1);
            }
          }

          &__icono {
            @extend .text-primary, .bg-secondary, .p-3, .rounded-circle;
          }
        }
      }
    }
  }
</style>
